import { Box, Container, Grid, Typography } from "@mui/material"
import { useApiGet, useApiPost } from "auth/useApi2"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { PageTabs } from "components/navigation/PageTabs/PageTabs"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import React, { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { DeviceForm } from "../../components/DeviceForm"
import { useTranslation } from "react-i18next"

const DeviceRegisterAdd = () => {
  const { t } = useTranslation()
  const [addDeviceResult, addDevice] = useApiPost()
  const routerHistory = useHistory()
  const loadingContext = React.useContext(GlobalLoaderContext)

  const handleSubmit = (objectToSave) => {
    addDevice(apiEndpoints.systemadmindeviceregistry.adddevice, objectToSave)
  }

  useEffect(() => {
    if (addDeviceResult.status === 2) routerHistory.push(allRoutes.SystemadminDevicesRegister())
  }, [addDeviceResult.status, routerHistory])

  const feedback = {
    errorTitle: t("sysadmin.unit_could_not_be_created", "Unit could not be created")
  }

  const [companyResult, getCompany] = useApiGet()
  const [externalDeviceResult, getExternalDevice] = useApiGet()

  useEffect(() => {
    loadingContext.setLoading(() => companyResult.status === 1)
  })

  useEffect(() => {
    loadingContext.setLoading(() => externalDeviceResult.status === 1)
  })

  useEffect(() => {
    getCompany(apiEndpoints.systemadmindeviceregistry.listcompanies)
    getExternalDevice(apiEndpoints.systemadmindeviceregistry.listexternaldeviceregistrydevicetypes)
  }, [getCompany, getExternalDevice])

  return (
    <div>
      <PageTabs
        routeBack
        tabs={[
          {
            path: allRoutes.SystemadminDevicesRegister(),
            title: t("global.back", "Back")
          }
        ]}
      />
      <Container>
        <Box marginY={3}>
          <Grid container direction="row" justifyContent="flex-start" alignItems="center">
            <Typography variant="h2">{t("global.add_device", "Add device")}</Typography>
          </Grid>
        </Box>

        {companyResult.status === 2 && externalDeviceResult.status === 2 && (
          <DeviceForm onSubmit={handleSubmit} feedback={feedback} result={addDeviceResult} />
        )}
      </Container>
    </div>
  )
}

export default DeviceRegisterAdd
